import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { IRelatedSeriesItem, getRelatedSeries } from '../../services/index'
import SeriesCard from 'Components/new/series-card'
import classNames from 'classnames'
import relatedSeriesTeaEvent from './tea'
import * as ZT from 'Constants/zt'
import * as LS from 'Constants/link-source'
import { useRouter } from 'next/router'
import getPageEnterId from 'lib/page-enter'

interface IProps {
  list?: any
  groupId: string
  cityName?: string
  isVideo?: boolean
  data?: IRelatedSeriesItem[]
}
const Floor: React.FC<IProps> = ({ groupId, isVideo, cityName, data = [] }) => {
  const [list, setList] = useState<IRelatedSeriesItem[]>(data || [])
  const [fontStyleString, setFontStyleString] = useState('')
  const navigationPrevRef = React.useRef<HTMLElement>(null)
  const navigationNextRef = React.useRef<HTMLElement>(null)
  const router = useRouter()
  const clueMap: Record<string, Record<'zt' | 'ls', string>> = {
    page_pgc_article_detail: {
      zt: ZT.ZT_0013,
      ls: LS.LS_0007,
    },
    page_feed_article_mix: {
      zt: isVideo ? ZT.ZT_0008 : ZT.ZT_0010,
      ls: isVideo ? LS.LS_0005 : LS.LS_0006,
    },
  }
  const currentClue = clueMap[getPageEnterId(router.asPath).page_id]
  useEffect(() => {
    const init = async () => {
      if (data?.length > 0) {
        return
      }
      if (!cityName) {
        return
      }
      if (!groupId) {
        console.warn('无法获取groupId,相关车系不展现!')
        return
      }
      const res = await getRelatedSeries(null, groupId, cityName)

      setFontStyleString(res?.fontStyleString)
      setList(res?.data || [])
    }
    init()
  }, [groupId, cityName])

  if (list?.length === 0) {
    return null
  }
  return (
    <>
      <div
        data-log-extra={JSON.stringify({
          module_id: 'related_series_h_module',
        })}
        data-log-view-config={JSON.stringify({
          repeated: true,
        })}
        data-log-view={JSON.stringify({
          event: 'show_event',
          params: {
            event_id: 'related_series_module',
          },
        })}
        className="floor-card related-series"
      >
        <div
          className={`tw-flex tw-justify-between tw-items-center tw-h-22 tw-mb-13`}
        >
          <h2 className={`tw-text-20 tw-leading-28 tw-font-semibold`}>
            相关车系
          </h2>
          {list.length > 2 && (
            <div className="tw-flex">
              <i
                id="navigationPrev"
                className={classNames(
                  'series-card-swiper-button',
                  'DCD_Icon icon_arrow_left_1',
                  'tw-w-30 tw-h-30 tw-leading-28 tw-rounded-15 tw-text-center',
                  'tw-border-1 tw-border-color-gray-600 tw-bg-white tw-cursor-pointer',
                  'hover:tw-border-common-black'
                )}
                ref={navigationPrevRef}
              />
              <i
                id="navigationNext"
                className={classNames(
                  'series-card-swiper-button',
                  'DCD_Icon icon_into_12',
                  'tw-w-30 tw-h-30 tw-leading-28 tw-rounded-15 tw-text-center',
                  'tw-border-1 tw-border-color-gray-600 tw-bg-white tw-cursor-pointer',
                  'hover:tw-border-common-black'
                )}
                ref={navigationNextRef}
              />
            </div>
          )}
        </div>
        <div className={`content-wrap`}>
          <Swiper
            slidesPerGroup={2}
            slidesPerView={'auto'}
            speed={450}
            spaceBetween={6}
            watchOverflow={true}
            preventClicks={false}
            observeParents={true}
            observer={true}
            resizeObserver={true}
            // 使用ref传递element在firefox小屏上进入时ref未能正确赋值，改用css selector
            // 原因未知
            navigation={{
              nextEl: '#navigationNext',
              prevEl: '#navigationPrev',
            }}
            simulateTouch={false}
            loop={false}
          >
            {list?.map((item: IRelatedSeriesItem, index: number) => (
              <SwiperSlide className="wrap" key={index}>
                {/* <RelatedCarCard data={item} isVideo={isVideo} /> */}
                <SeriesCard
                  seriesId={item.series_id}
                  name={item.series_name}
                  coverUrl={item.cover_url}
                  score={item.dcd_score}
                  price={item.min_dealer_price}
                  noPrice={
                    !item.min_dealer_price ||
                    item.min_dealer_price.includes('暂无')
                  }
                  carIds={item.online_car_ids as any}
                  noImage={!item.series_pic_count}
                  noCar={!item.online_car_ids?.length}
                  brandId={item.brand_id}
                  brandLogo={item.brand_logo}
                  brandName={item.brand_name}
                  maxReducePrice={item.max_reduce_price}
                  usedCarCount={item.sku_count}
                  hasQA={item.has_question}
                  zt={currentClue.zt}
                  linkSource={currentClue.ls}
                  onClick={(type, text) =>
                    relatedSeriesTeaEvent(type, {
                      car_series_id: item.series_id,
                      car_series_name: item.series_name,
                      button_name: text,
                    })
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <style jsx>
          {`
            .floor-card {
            }
            .title {
              font-size: 20px;
              font-weight: 600;
              color: #1f2129;
            }
            .content-wrap {
              position: relative;
            }
            :global(.related-series .wrap) {
              width: auto;
            }
            .series-card-swiper-button {
              display: inline-block;
            }
            .series-card-swiper-button.swiper-button-disabled {
              cursor: default;
              color: #e6e8f2;
              border-color: transparent;
              background-color: transparent;
            }
          `}
        </style>
        <style>{fontStyleString}</style>
      </div>
    </>
  )
}

export default Floor
